import {combineReducers} from 'redux';

import TicketsReducer from './states/tickets/reducer';
import ServerStatisticsReducer from './states/servers/reducer';

const statisticsReducer = combineReducers({
    tickets: TicketsReducer,
    servers: ServerStatisticsReducer,
});


export default statisticsReducer;